import { Create } from "react-admin";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import ChefForPartyNormalForm from "./ChefForPartyNormalForm";
import BookByDishCreateForm from "../BookByDish/BookByDishCreateForm";
import { ChefForPartyBookingTypeEnum } from "../../enums/ChefForPartyBookingTypeEnum";

const ChefForPartyCreate = () => {
    const location = useLocation();
    // Capture the type once on mount. Child list dialogs update URL query params
    // for pagination which would strip ?type= and flip the form on every page click.
    const bookingType = useRef(
        new URLSearchParams(location.search).get("type") as ChefForPartyBookingTypeEnum | null
    );

    if (bookingType.current === ChefForPartyBookingTypeEnum.BOOK_BY_DISH) {
        return (
            <Create title={"Create Book by Dish"} sx={{ "& .RaCreate-main": { width: "100%" } }}>
                <BookByDishCreateForm />
            </Create>
        );
    }

    // CHEF_FOR_PARTY or no type in URL — always show the normal form
    return (
        <Create title={"Create Chef for Party"} sx={{ "& .RaCreate-main": { width: "100%" } }}>
            <ChefForPartyNormalForm />
        </Create>
    );
};

export default ChefForPartyCreate;
